import api from "./api";

export const buyCourse = (courseId) => {
  return api.post(`/purchases/${courseId}`);
};

export const getMyPurchases = () => {
  return api.get("/purchases");
};